import { useState, useEffect } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { Label } from './ui/label';

const DateOfBirthInput = ({ value, onChange, label = "Date of Birth", required = false, className = "", yearsBack = 75 }) => {
  const [day, setDay] = useState('');
  const [month, setMonth] = useState('');
  const [year, setYear] = useState('');

  // Parse initial value
  useEffect(() => {
    if (value) {
      const date = new Date(value);
      if (!isNaN(date.getTime())) {
        setDay(date.getDate().toString());
        setMonth((date.getMonth() + 1).toString());
        setYear(date.getFullYear().toString());
      }
    }
  }, []);

  // Update parent when all fields are filled
  useEffect(() => {
    if (day && month && year) {
      const dateStr = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
      onChange(dateStr);
    }
  }, [day, month, year]);

  const days = Array.from({ length: 31 }, (_, i) => i + 1);
  const months = [
    { value: '1', label: 'January' },
    { value: '2', label: 'February' },
    { value: '3', label: 'March' },
    { value: '4', label: 'April' },
    { value: '5', label: 'May' },
    { value: '6', label: 'June' },
    { value: '7', label: 'July' },
    { value: '8', label: 'August' },
    { value: '9', label: 'September' },
    { value: '10', label: 'October' },
    { value: '11', label: 'November' },
    { value: '12', label: 'December' }
  ];
  
  // Generate years from current year going back (default 75 years to support adults/guardians)
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: yearsBack }, (_, i) => currentYear - i);

  return (
    <div className={className}>
      {label && (
        <Label className="text-white/70 mb-2 block">
          {label} {required && <span className="text-[#FF007F]">*</span>}
        </Label>
      )}
      <div className="grid grid-cols-3 gap-2">
        <Select value={day} onValueChange={setDay}>
          <SelectTrigger className="bg-[#0a0a0a] border-[#333] text-white" data-testid="dob-day">
            <SelectValue placeholder="Day" />
          </SelectTrigger>
          <SelectContent className="bg-[#111] border-[#333] max-h-60">
            {days.map(d => (
              <SelectItem key={d} value={d.toString()} className="text-white hover:bg-[#222]">
                {d}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={month} onValueChange={setMonth}>
          <SelectTrigger className="bg-[#0a0a0a] border-[#333] text-white" data-testid="dob-month">
            <SelectValue placeholder="Month" />
          </SelectTrigger>
          <SelectContent className="bg-[#111] border-[#333] max-h-60">
            {months.map(m => (
              <SelectItem key={m.value} value={m.value} className="text-white hover:bg-[#222]">
                {m.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>

        <Select value={year} onValueChange={setYear}>
          <SelectTrigger className="bg-[#0a0a0a] border-[#333] text-white" data-testid="dob-year">
            <SelectValue placeholder="Year" />
          </SelectTrigger>
          <SelectContent className="bg-[#111] border-[#333] max-h-60">
            {years.map(y => (
              <SelectItem key={y} value={y.toString()} className="text-white hover:bg-[#222]">
                {y}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default DateOfBirthInput;
